import type { DungeonShopConfig } from "@/dungeon/dungeon-shop-types";
import { resolveMonsterShopEntry } from "@/dungeon/dungeon-shop-types";
import { goldBoughtCount, vaultStock } from "@/dungeon/dungeon-monster-vault";
import {
  GM_MONSTER_PLACEHOLDER_IMAGE,
  type GmMonsterTemplate,
} from "@/gm/gm-monster-catalog";
import { HOME_ASSETS } from "@/home/home-assets";
import type { HomeEconomy } from "@/home/economy";

function escapeHtml(text: string): string {
  return text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

function monsterThumb(m: GmMonsterTemplate): string {
  return m.imageDataUrl?.startsWith("data:") ? m.imageDataUrl : GM_MONSTER_PLACEHOLDER_IMAGE;
}

export function renderDungeonMonsterShopPanel(
  economy: HomeEconomy,
  shop: DungeonShopConfig,
  catalog: GmMonsterTemplate[],
): string {
  if (catalog.length === 0) {
    return `<p class="hint home-shop-empty">GM ยังไม่มีมอนสเตอร์ในแคตตาล็อก</p>`;
  }
  const wallet = `<p class="hint">ทอง <strong id="dungeon-vault-wallet-coins">${economy.wallet.coins.toLocaleString("en-US")}</strong> · Cash <strong id="dungeon-vault-wallet-cash">${economy.wallet.cash.toLocaleString("en-US")}</strong></p>`;
  const cards = catalog
    .map((m) => {
      const entry = resolveMonsterShopEntry(shop, m.id);
      const stock = vaultStock(economy, m.id);
      const goldBought = goldBoughtCount(economy, m.id);
      return `
          <article class="dungeon-monster-shop-card" data-monster-id="${escapeHtml(m.id)}">
            <img class="dungeon-monster-shop-thumb" src="${escapeHtml(monsterThumb(m))}" alt="" width="40" height="40" />
            <div class="dungeon-monster-shop-meta">
              <p class="dungeon-monster-shop-name">${escapeHtml(m.name)}</p>
              <p class="hint dungeon-monster-shop-owned">คลัง ${stock.toLocaleString("en-US")} ตัว</p>
              <p class="hint">ทอง ${goldBought}/${entry.goldMaxUnits} · Cash (∞)</p>
            </div>
            <div class="dungeon-monster-shop-actions">
              <button type="button" class="btn btn-ghost btn-xs dungeon-vault-buy-monster" data-currency="gold" data-monster-id="${escapeHtml(m.id)}">
                <img src="${HOME_ASSETS.coin}" width="14" height="14" alt="" /> ${entry.goldPricePerUnit}
              </button>
              <button type="button" class="btn btn-ghost btn-xs dungeon-vault-buy-monster" data-currency="cash" data-monster-id="${escapeHtml(m.id)}">
                $ ${entry.cashPricePerUnit}
              </button>
            </div>
          </article>`;
    })
    .join("");
  return `${wallet}<div class="dungeon-monster-shop-list dungeon-monster-shop-list--vault">${cards}</div>`;
}

export function refreshDungeonMonsterShopPanelDom(
  root: ParentNode,
  economy: HomeEconomy,
  shop: DungeonShopConfig,
  catalog: GmMonsterTemplate[],
): void {
  const host = root.querySelector<HTMLElement>("#currency-shop-items-monsters");
  if (!host) return;
  host.innerHTML = renderDungeonMonsterShopPanel(economy, shop, catalog);
  const walletCoins = root.querySelector<HTMLElement>("#dungeon-vault-wallet-coins");
  const walletCash = root.querySelector<HTMLElement>("#dungeon-vault-wallet-cash");
  if (walletCoins) walletCoins.textContent = economy.wallet.coins.toLocaleString("en-US");
  if (walletCash) walletCash.textContent = economy.wallet.cash.toLocaleString("en-US");
}
